import { Box, CircularProgress, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import { useState } from 'react';
import { scrollbarStyle } from '../../../shared/dashboard';
import { ExtendedComment } from '../../../types/comments';
import { CompanyFile } from '../../../types/files';
import FilePreview from '../../atoms/FilePreview';
import FileCategories from '../../atoms/FileCategories';
import DashboardCategoriesNavigation from './DashboardCategoriesNavigation';

const useStyles = makeStyles(() => ({
    root: {
        borderRight: `2px solid #F7F5F2`,
        overflow: 'auto',
        marginLeft: 16,
        position: 'relative',
        '-moz-transition': 'width .3s',
        '-ms-transition': 'width .3s',
        '-o-transition': 'width .3s',
        '-webkit-transition': 'width .3s',
        transition: 'width .3s ease-out',
    },
    container: {
        width: "40%"
    },
    header: {
        marginLeft: 66
    },
    folderListProgress: {
        display: "flex",
        justifyContent: "center"
    },
    noFileSelected: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        width: "100%",
        height: "100%",
        overflow: "auto",
        '-moz-transition': 'width .3s',
        '-ms-transition': 'width .3s',
        '-o-transition': 'width .3s',
        '-webkit-transition': 'width .3s',
        transition: 'width .3s ease-out',
        ...scrollbarStyle
    },
}));

const DashboardCategoriesLayout: React.FC<{
    dashboardId: string
    selectedComment?: ExtendedComment,
    selectedFile?: CompanyFile,
    selectedFolder?: CompanyFile,
    selectedPage?: number,
    isPublic?: boolean,
    onSelectFile: (f: CompanyFile | null) => void
    onSelectFolder: () => void,
    loading: boolean
}> = ({ dashboardId, selectedComment, selectedFile, selectedFolder, selectedPage, isPublic, onSelectFile, loading }) => {
    const classes = useStyles();
    const [menuExpanded, setMenuExpanded] = useState<boolean>(false);
    const [, setSelectedCategory] = useState<string>();

    const filePreview = (
        <FilePreview
            filePath={selectedFile?.path}
            fileKey={selectedFile?.key || ""}
            page={selectedPage} />
    );

    const fileCategories = (
        <FileCategories
            dashboardId={dashboardId}
            onFileSelect={(file: CompanyFile) => {
                onSelectFile(file);
            }}
        />
    );

    const content = (selectedFolder && selectedFile) ? filePreview : fileCategories;

    return (
        <Box
            position="relative"
            width="100%"
            maxWidth="calc(100vw - 114px)"
            height='calc(100vh - 70px)'
            maxHeight='calc(100vh - 70px)'
            display="flex"
            flexDirection="row"
        >
            <Box
                className={classNames(classes.root, "no-scrollbar")}
                height="100%"
                width={menuExpanded ? 400 : 114}
                onMouseEnter={() => setMenuExpanded(true)}
                onMouseLeave={() => setMenuExpanded(false)}
            >
                {!isPublic && (
                    loading ?
                        <div className={classes.folderListProgress}>
                            <CircularProgress />
                        </div>
                        :
                        <DashboardCategoriesNavigation
                            dashboardId={dashboardId}
                            onFileSelected={onSelectFile}
                            selectedFile={selectedFile}
                            isMenuExpanded={menuExpanded}
                            onExpandMenu={setMenuExpanded}
                            setSelectedCategory={setSelectedCategory}
                        />
                )}
            </Box>
            <Box className={classes.content}>
                {content ? content : (
                    <div className={classes.noFileSelected}><Typography>No file selected.</Typography></div>
                )}
            </Box>
        </Box>
    )
}

export default DashboardCategoriesLayout;
